// extracted by mini-css-extract-plugin
export default {"col":"styles_col__uWjFN","item":"styles_item__PoE6v"};